/**
 * Query strings needing values are ones ending in :
 */
export default function isQueryStringNeedingValue(queryString) {
  return !!(queryString && queryString.match(/:$/))
}
